import {LIMIT_GQV} from '/enum/limit.enum';
import {getNumberCapper} from '/util/number.util';

export const capGQV = (gqv: any) => {
  const capGQVValue = getNumberCapper(LIMIT_GQV);

  return capGQVValue(gqv);
};
